"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCsvFieldsExtractor = exports.assignmentHistoryExtractor = exports.vehiclesExtractor = exports.successExtractor = exports.vehicleExtractor = exports.VehicleGroup = exports.REAL_TIME_EVENTS = void 0;
exports.REAL_TIME_EVENTS = {
    VEHICLE_UPDATE: 'vehicle update',
    VEHICLE_DELETE: 'vehicle delete',
    VEHICLE_UNASSIGNED: 'vehicle removed'
};
var VehicleGroup;
(function (VehicleGroup) {
    VehicleGroup["Team"] = "team_id";
    VehicleGroup["IsTrailer"] = "is_trailer";
})(VehicleGroup = exports.VehicleGroup || (exports.VehicleGroup = {}));
var vehicleExtractor = function (response) { return response.vehicle; };
exports.vehicleExtractor = vehicleExtractor;
var successExtractor = function (response) { return response.success; };
exports.successExtractor = successExtractor;
var vehiclesExtractor = function (response) { return response.vehicles; };
exports.vehiclesExtractor = vehiclesExtractor;
var assignmentHistoryExtractor = function (response) { return response.changes; };
exports.assignmentHistoryExtractor = assignmentHistoryExtractor;
var getCsvFieldsExtractor = function (response) { return response.csv_upload_fields; };
exports.getCsvFieldsExtractor = getCsvFieldsExtractor;
//# sourceMappingURL=Vehicle.consts.js.map